import "./footer.scss"

function Footer(){
  return(
    <footer data-testid="footer-1">
      <section className='footer__left'>
      </section>
      <section className='footer__middle'>
        <span>2020-2026</span>
      </section>
      <section className='footer__right'>
        <p><a href="https://itsmemada.github.io/Portfolio/">https://itsmemada.github.io/Portfolio/</a></p>
      </section>
    </footer>
  )
}
export default Footer
